/* Subtotal footer — sticky price + "Done" button area */

export const subtotalFooterParts = [
  'subtotalFooter',
  'subtotalInfo',
  'subtotalTitle',
  'subtotalSelectionSummary',
  'subtotalPrice',
  'subtotalDoneButton',
  'subtotalThumbnail',
  'subtotalPriceSubtitle'
];

export const subtotalFooterBaseStyle = {
  subtotalFooter: {
    alignItems: 'center',
    backdropFilter: 'blur(20px)',
    bg: 'rgba(255, 255, 255, 0.8)',
    borderTop: '1px solid',
    borderColor: 'grayAlpha.10',
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.10)',
    display: 'flex',
    flexShrink: 0,
    gap: 4,
    paddingX: 6,
    paddingY: 3,
    sx: {
      '& p': {
        margin: 0,
      },
    },
  },
  subtotalInfo: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 1,
    minWidth: 0,
  },
  subtotalTitle: {
    color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
    fontSize: {base: '1xs', lg: 'xs'},
    fontWeight: 'semibold',
    lineHeight: '1.2',
    display: 'block',
    minW: 0,
    maxW: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  /** Full configuration line when all flyout steps are complete (FSD §5.2). */
  subtotalSelectionSummary: {
    alignSelf: 'stretch',
    color: 'brandColors.greyscale90',
    display: 'block',
    fontFamily: 'body',
    fontSize: {base: '13px', md: '12px'},
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    maxW: '100%',
    minW: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  subtotalPrice: {
    color: 'brandColors.greyscale60',
    fontFamily: 'body',
    fontSize: {base: '0.8125rem', lg: '0.75rem'},
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 1.2,
    noOfLines: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtotalDoneButton: {
    alignItems: 'center',
    bg: {base: 'brandColors.greyscale', lg: 'gray.900'},
    border: '1px solid',
    borderColor: {base: 'brandColors.greyscale', lg: 'gray.900'},
    borderRadius: 'base',
    color: 'text.white',
    display: 'flex',
    flexShrink: 0,
    fontFamily: 'body',
    fontSize: {base: 'sm', lg: 'md'},
    fontStyle: 'normal',
    fontWeight: 600,
    gap: 2,
    height: 13.5,
    justifyContent: 'center',
    lineHeight: 1.4,
    textAlign: 'center',
    paddingY: {base: 4, lg: 4},
    paddingX: {base: 8, lg: 8},
    _active: {
      bg: {base: 'brandColors.greyscale', lg: 'gray.900'},
    },
    _disabled: {
      bg: 'grayAlpha.10',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'gray.400',
      cursor: 'not-allowed',
      opacity: 1,
      _hover: {
        bg: 'grayAlpha.10',
        borderColor: 'transparent',
        boxShadow: 'none',
      },
    },
    _hover: {
      bg: {base: 'brandColors.greyscale', lg: 'gray.900'},
    },
    _focusVisible: {
      boxShadow: 'none',
      outline: '2px solid',
      outlineColor: 'brandColors.primaryDarkLinen',
      outlineOffset: '2px',
    },
  },
  subtotalThumbnail: {
    borderRadius: 'md',
    flexShrink: 0,
    height: '32px',
    objectFit: 'cover',
    width: '32px',
  },

  subtotalPriceSubtitle: {
    color: 'brandColors.greyscale60',
    fontSize: {base: '0.8125rem', lg: '0.75rem'},
    lineHeight: '1.2',
    sx: {
      '& b, & strong': {
        fontWeight: 400,
      },
    },
  },
};
